import C from  '../constants/home';
import {dispatchAjaxResponseWithCharger} from '../utils/helpers';

export function getWidgets() {
	let url = 'api/v1/sc/widgetsData';
	return dispatchAjaxResponseWithCharger(url,C.GET_WIDGET_LIST);
}


// WEBPACK FOOTER //
// ./actions/home.js